import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import { ConfigService } from 'app/services';
import { Utils } from 'app/utils';
import { StylesStatus } from 'app/models/users/StylesStatus';
import { DigitTypeEnum, FieldTypeEnum } from 'app/models';
import {UserManagementService} from 'app/services/user-management.service';
import {EditTableConfig} from 'app/models/configs/edit-table-config';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'user-managment-roles',
    templateUrl: './user-managment-roles.component.html',
    styleUrls: ['./user-managment-roles.component.scss',
        '../../../../../styles/paginator.scss'],
    providers: [MessageService]
})
export class UserManagmentRolesComponent implements OnInit {
    @Input()
    public menuPermissionActive!: string;

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    fieldTypeEnum = FieldTypeEnum;
    roles: Array<any> = [];
    selectedRole: any = undefined;
    isVisibleRolesDetails: boolean = false;
    cols: any[] = [
        {
            disableSort: false,
            field: 'Name',
            fieldType: FieldTypeEnum.Inputs,
            header: 'Name',
            model: 'Name',
            placeholder: 'Type here',
            showSortIcon: true,
            width: '10%',
            active: false
        },
        {
            field: 'Description',
            header: 'Description',
            width: '20%',
            disableSort: false,
            showSortIcon: true,
            model: 'Description',
            fieldType: FieldTypeEnum.Inputs,
            placeholder: 'Type here',
            active: false
        },
        {
            disableSort: false,
            field: 'UserAssignedCount',
            fieldType: FieldTypeEnum.Inputs,
            header: 'User Assigned',
            model: 'UserAssignedCount',
            placeholder: 'Type here',
            showSortIcon: true,
            width: '20%',
            active: false
        },
        {
            field: 'Type',
            header: 'Type',
            width: '20%',
            disableSort: false,
            showSortIcon: true,
            model: 'Type',
            fieldType: FieldTypeEnum.Inputs,
            placeholder: 'Type here',
            active: false
        }
    ];

    txnHeaderSearch: any = {
        Id: null,
        Name: null,
        Description: null,
        UserAssignedCount: null,
        Type: null,
    };

    // Grid settings
    rowsPerPage: number = Utils.getRowsPerPageCount();
    totalRecords: number = -1;
    first: number = 0;
    sortField: string | string[] = '';
    sortOrder: number = 1;
    loading: boolean = true;

    filter: {
        searchName: string;
        startDateJoin: Date | undefined;
        endDateJoin: Date | undefined;
        digitType: DigitTypeEnum | undefined;
    } = { searchName: '', startDateJoin: undefined, endDateJoin: undefined, digitType: undefined };
    selectedUsers: Array<any> = [];
    searchTimer: number = 0;
    suspendUser: {
        userId: number | null;
        userName: string | null;
    } = { userId: null, userName: null };

    tableName: string = EditTableConfig.USER_MANAGMENT_ROLES;
    selectedColumns: any[] = [];
    public breadcrumbs: MenuItem[] = [{ icon: 'icon_settings' },{ label: 'Settings' },{ label: 'User Management' },{ label: 'Roles' }];

    constructor(
        private messageService: MessageService,
        private userManagmentService: UserManagementService,
        public configService: ConfigService
    ) {
    }

    ngOnInit(): void {
    }

    onSelectedColumnsChange(event: any[]) {
        if (event && event.length > 0) {
            this.selectedColumns = event;
        }
        else {
            this.selectedColumns = this.cols;
        }
    }

    handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.tableName);
        }

        this.getRoles(skip);
    }

    getRoles(skip: number) {
        this.loading = true;
        const dto = {
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            TimeZoneOffset: Utils.getTimezoneOffset()
        };
        this.userManagmentService.getRoles(dto, this.messageService)
            .then(data => {
                if (!data.Success) {
                    this.loading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.first = skip;
                this.totalRecords = data.TotalRecords;
                this.roles = data.Items;
                this.loading = false;
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    onSelectionChange(value = []) {
        this.selectedUsers = value;
    }

    handleFilterChange(model: string, event: any): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getRoles(0);
            this.searchTimer = 0;
        }, 1500);
    }

    onChangeHeaderFilterDropDown(model: string, event: any) {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getRoles(0);
            this.searchTimer = 0;
        }, 1000);
    }

    handlePopupLinkClick(role: any): void {
        this.selectedRole = role;
        this.isVisibleRolesDetails = role !== undefined;
    }

    changedVisibleRolesDetailsEmit(value: boolean) {
        this.isVisibleRolesDetails = false;
        if (value) {
            this.getRoles(0);
        }
    }

    onCreateRoleClick(): void {
        this.isVisibleRolesDetails = true;
        this.selectedRole = {
            Name: ''
        };
    }

    getStatusStyles(status: string): StylesStatus {
        let backgroundColor: string;
        let textColor: string;

        switch (status) {
            case 'Active':
                backgroundColor = '#E7F7EF';
                textColor = '#1CBA70';
                break;
            case 'Non active':
            case 'Offline':
                backgroundColor = '#FDEBEA';
                textColor = '#EB4236';
                break;
            default:
                backgroundColor = '';
                textColor = '';
        }

        return {
            backgroundColor,
            color: textColor
        };
    }

    handleHeaderFilterChange(event: any) {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.getRoles(0);
            this.searchTimer = 0;
        }, 1500);
    }
}
